
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 13","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.92 12.112a5.6 5.6 0 01-2.24-.448A5.797 5.797 0 01.624 8.608a5.561 5.561 0 01-.448-2.224 5.609 5.609 0 011.68-4.048A5.797 5.797 0 013.68 1.104 5.601 5.601 0 015.92.656c.79 0 1.53.15 2.224.448.693.299 1.301.71 1.824 1.232A5.46 5.46 0 0111.2 4.16c.299.683.448 1.424.448 2.224 0 .79-.15 1.53-.448 2.224a5.797 5.797 0 01-3.056 3.056 5.56 5.56 0 01-2.224.448zm.224-2.464c-1.013 0-1.765-.261-2.256-.784-.49-.533-.736-1.365-.736-2.496 0-2.165 1.008-3.248 3.024-3.248.277 0 .56.027.848.08.288.053.528.128.72.224.192.085.288.187.288.304 0 .075-.032.17-.096.288a1.591 1.591 0 01-.192.32c-.075.096-.144.144-.208.144a.661.661 0 01-.208-.08 1.86 1.86 0 00-.448-.176 2.63 2.63 0 00-.72-.08c-.608 0-1.061.181-1.36.544-.288.363-.432.923-.432 1.68 0 .757.144 1.328.432 1.712.299.373.747.56 1.344.56.299 0 .55-.032.752-.096.213-.075.384-.144.512-.208.128-.075.213-.112.256-.112.075 0 .144.053.208.16.075.096.133.197.176.304.053.107.08.187.08.24 0 .139-.112.267-.336.384a3.22 3.22 0 01-.784.256c-.299.053-.587.08-.864.08zm-.224 1.52c.661 0 1.28-.123 1.856-.368a5.003 5.003 0 001.52-1.04 4.65 4.65 0 001.04-1.52 4.59 4.59 0 00.384-1.856c0-.672-.128-1.29-.384-1.856a4.65 4.65 0 00-1.04-1.52 4.65 4.65 0 00-1.52-1.04A4.727 4.727 0 005.904 1.6c-.65 0-1.27.123-1.856.368a4.65 4.65 0 00-1.52 1.04 5.003 5.003 0 00-1.04 1.52 4.612 4.612 0 00-.368 1.856c0 .65.123 1.27.368 1.856a5.003 5.003 0 002.56 2.56c.587.245 1.21.368 1.872.368z","fill":"currentColor"}})])
          )
        }
      }
    